import React from 'react';
import { Link } from 'react-scroll';
import { FacebookIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  const quickLinks = ['Home', 'About', 'Services', 'Portfolio', 'Contact'];
  return <footer className="bg-[#0f0f0f] border-t border-gray-800" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 md:py-12" data-id="element-139">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8" data-id="element-140">
          {/* Brand */}
          <div data-id="element-141">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4" data-id="element-142">
              Renova<span className="text-[#d4af37]" data-id="element-143">8</span> & Build
            </h3>
            <p className="text-gray-400 mb-3 sm:mb-4 text-sm sm:text-base" data-id="element-144">
              Luxury renovations and construction services in Brisbane
            </p>
            <a href="https://renova8build.com.au" target="_blank" rel="noopener noreferrer" className="text-[#d4af37] hover:text-[#4b4bff] transition-colors text-sm sm:text-base break-all" data-id="element-145">
              renova8build.com.au
            </a>
          </div>
          {/* Quick Links */}
          <div data-id="element-146">
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base" data-id="element-147">
              Quick Links
            </h4>
            <ul className="space-y-1 sm:space-y-2" data-id="element-148">
              {quickLinks.map(link => <li key={link} data-id="element-149">
                  <Link to={link.toLowerCase()} smooth={true} duration={500} className="text-gray-400 hover:text-[#d4af37] transition-colors cursor-pointer text-sm sm:text-base" data-id="element-150">
                    {link}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Social Links */}
          <div className="sm:col-span-2 lg:col-span-1" data-id="element-151">
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base" data-id="element-152">
              Follow Us
            </h4>
            <div className="flex gap-3 sm:gap-4" data-id="element-153">
              <a href="https://www.facebook.com/share/1a6Hi1pEos/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1c1c1c] rounded-full flex items-center justify-center text-gray-400 hover:bg-[#d4af37] hover:text-[#1c1c1c] transition-all active:scale-90 touch-manipulation" data-id="element-154">
                <FacebookIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-155" />
              </a>
              <a href="https://www.instagram.com/renova8build?igsh=cWtmM2NqcTEwOTBm&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1c1c1c] rounded-full flex items-center justify-center text-gray-400 hover:bg-[#d4af37] hover:text-[#1c1c1c] transition-all active:scale-90 touch-manipulation" data-id="element-156">
                <InstagramIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-157" />
              </a>
            </div>
          </div>
        </div>
        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8 text-center" data-id="element-158">
          <p className="text-gray-400 text-xs sm:text-sm px-4" data-id="element-159">
            © 2025 Renova8 & Build | Luxury Renovations Brisbane | All Rights
            Reserved
          </p>
        </div>
      </div>
    </footer>;
}